import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=4d841470&scoped=true&"
import script from "./Part.vue?vue&type=script&lang=js&"
export * from "./Part.vue?vue&type=script&lang=js&"
import style0 from "./Part.vue?vue&type=style&index=0&id=4d841470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d841470",
  null
  
)

export default component.exports